import { useState } from 'react'
import FilterListIcon from '@mui/icons-material/FilterList'
import styles from './styles.module.css'

interface BasicFilterProps {
  onEnter?: Function
  onChange?: Function
}

function BasicFilter({ onEnter, onChange }: BasicFilterProps) {
  const [message, setMessage] = useState('')

  function handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
    if (onEnter && event.key === 'Enter') {
      onEnter(message)
    }
  }

  function handleChange(event: any) {
    setMessage(event.target.value)
    if (onChange) {
      onChange(event.target.value)
    }
  }

  return (
    <span className={styles.filterInputWrapper}>
      <input
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={'Filter'}
        className={styles.filterInput}
      />
      <FilterListIcon className={styles.filterIcon} />
    </span>
  )
}

export default BasicFilter
